import { createContext, useState } from "react";

const LoaderContext = createContext(false);
const LoaderDispatchContext = createContext((value) => {});

const LoaderProvider = ({ children }) => {
  const [loaderState, setLoaderState] = useState(false);
  return (
    <LoaderContext.Provider value={loaderState}>
      <LoaderDispatchContext.Provider value={setLoaderState}>
        {children}
      </LoaderDispatchContext.Provider>
    </LoaderContext.Provider>
  );
};

export { LoaderProvider, LoaderContext, LoaderDispatchContext };
